import { Injectable } from '@angular/core'
import { LaskunTila } from '@lemon/core-firebase/model/lasku'
import { NumberDate } from '@lemon/core/model/common'

export interface LaskuHakuTila {
  hakuteksti: string
  viimeiset12kkAktiivinen: boolean
  alkuPvm: NumberDate | null
  loppuPvm: NumberDate | null
  valitutTilat: LaskunTila[]
  valitutAsiakkaat: string[]
  naytaSummatVerottomina: boolean
  valitutProjektit: string[]
  sivu: number
  sivunKoko: number
  paluureitti: string
}

export interface RekisteriHakuTila {
  hakuteksti: string
  sivu: number
  sivunKoko: number
  paluureitti: string
}

/** Hakuoverlayn tila talletetaan ennen tulosrivin avausta ja palautetaan kertakäyttöisesti, kun listaukseen palataan */
class PalautettavaHakutila<T extends LaskuHakuTila | RekisteriHakuTila> {
  private _hakutila: T | null = null

  tallennaHakutila(hakutila: T) {
    this._hakutila = hakutila
  }

  onkoHakutilaTallennettu(paluureitti: string): boolean {
    return this._hakutila?.paluureitti === paluureitti
  }

  palautaHakutila(): T | null {
    const hakutila = this._hakutila
    this._hakutila = null
    return hakutila
  }
}

@Injectable()
export class LaskutusHakuStateService {
  readonly lasku = new PalautettavaHakutila<LaskuHakuTila>()
  readonly asiakas = new PalautettavaHakutila<RekisteriHakuTila>()
  readonly tuote = new PalautettavaHakutila<RekisteriHakuTila>()
}
